import { memo } from 'react'

import {
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material'

type OwnProps = {
  filters: string[]
  onChange: (filters: string[]) => void
}

const optionLabel = {
  APPROVAL: 'Согласование',
  SIGNING: 'Подписание',
  OTHER: 'Прочее',
}

const NotificationFilterInner = ({ filters, onChange }: OwnProps) => {
  return (
    <FormControl fullWidth>
      <InputLabel
        shrink
        id="filters-label"
        size="small"
        sx={{ align: 'center' }}
      >
        Фильтрация
      </InputLabel>
      {filters.length === 0 && (
        <Typography sx={{ position: 'absolute', left: 14, top: 8 }}>
          Все уведомления
        </Typography>
      )}
      <Select
        multiple
        notched
        defaultValue={[]}
        label="Фильтрация"
        labelId="filters-label"
        renderValue={filters => (
          <Typography>
            {filters.map(item => optionLabel[item]).join(',  ')}
          </Typography>
        )}
        size="small"
        onChange={event => onChange(event.target.value as string[])}
      >
        {Object.keys(optionLabel).map(key => (
          <MenuItem key={key} value={key}>
            <Stack direction="row" gap={1}>
              <Checkbox
                disableRipple
                checked={filters.some(filter => filter === key)}
                sx={{ p: 0 }}
              />
              <Typography>{optionLabel[key]}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export const NotificationFilter = memo(NotificationFilterInner)
